import "./index.scss";

import React from "react";
import _ from "lodash";
import { connect } from "react-redux";
import { EditorState, ContentState, convertFromRaw , convertToRaw} from 'draft-js';
import { Editor } from 'react-draft-wysiwyg';
import 'react-draft-wysiwyg/dist/react-draft-wysiwyg.css';
import Emoji from "Components/common/Functions/Editor/Actions/Emoji/Emoji";
// import Emoji from "./Actions/Emoji/Emoji";
import Inline from "./Inline/Inline";
import List from "./List/List";
import Actions from "./Actions/Actions";

let members = []
let allMembers = []
@connect(store => {
    return {
        conversations: store.conversations,
        project: store.project,
        loggedUser: store.loggedUser,
        conversation: store.conversation,
        task: store.task,
        files: store.files,
        document: store.document
    }
})

class TextEditor extends React.Component {
    constructor(props) {
        super(props);

        this.state = {
            contentState: null,
            editorState: EditorState.createEmpty(),
        };
        _.map(
            ["initMembers","isMessageEmpty","isJsonString"], fn => {
                this[fn] = this[fn].bind(this);
            }
        );
       
    }

    componentDidMount() {
        const { project, loggedUser, message,dispatch, type} = this.props
        const content = { "entityMap": {}, "blocks": [] };
        const contentState = message && Object.keys(message).length > 0 && message.comment && this.isJsonString(message.comment)  && message.comment.includes('{"blocks"')
        ?convertFromRaw(JSON.parse(message.comment)) 
        : message && message.comment && message.comment.length > 0
        ?  ContentState.createFromText(String(message.comment)): convertFromRaw(content)
        const editorState = EditorState.createWithContent(contentState);
        this.initMembers(project,loggedUser)
        this.setState({
            ...this.state,
            editorState
        });
    }
  
    shouldComponentUpdate(nextProps) {
        const {dispatch,type,document} = this.props;
        // handle populate mention list
        if(!_.isEqual(nextProps.project.Selected.members, this.props.project.Selected.members)){
            this.initMembers(nextProps.project, nextProps.loggedUser)
        }  
        if( !_.isEqual(nextProps.document.Selected.id, document.Selected.id)){
            //handle reset editor
            const editorState = EditorState.createWithContent(ContentState.createFromText(''));
            this.setState({
                ...this.state,
                editorState
            })
           
      }
        return true;
    }
    initMembers(project, loggedUser){
        const projectMembers = project.Selected.members ? project.Selected.members.filter(f => f.status === 'enabled') : []
        members = projectMembers.filter(m => m.id !== loggedUser.data.id).map(u => {
            return {
                text: `${u.user['first-name']} ${u.user['last-name']}`,
                value: `${u.user['first-name']} ${u.user['last-name']}`,
                url: u.id,
                userId: u.id
            }
        })
        allMembers = members
    } 
    isMessageEmpty(message){
        try {
           const obj = JSON.parse(message)
           if(obj.blocks.length === 1 && !obj.blocks[0].text) {
              return 0
           } 
               return message.length
        }  catch(error){
            return 0
        }
      
      }
    isJsonString(str) {
        try {
            JSON.parse(str);
        } catch (e) {
            return false;
        }
    
        return true;
    }
    render() {
        const { dispatch, conversations, project, type,message, conversation} = this.props;
   
        const onEditorStateChange = (editorState) => {
            this.setState({
                editorState,
            }, () => {
                setTimeout(() => {
                    if ($("#task-details").length > 0) {
                        var parentOffset = $("#task-details").offset();

                        if ($("#task-details .rdw-suggestion-dropdown").length > 0) {
                            $("#task-details .rdw-suggestion-dropdown").css({
                                "top": $(".rdw-suggestion-dropdown").parent().offset().top - (parentOffset.top - 25),
                                "left": $(".rdw-suggestion-dropdown").parent().offset().left - (parentOffset.left - 769),
                                "position": "unset",
                                "display": "flex"
                            });
                        }
                    }
                }, 50);
            });

        };
        const parseMention = (message) => {
            const mention = Object.keys(message.entityMap)
                .map(o => message.entityMap[o])
                .filter(f => f.type === 'MENTION')
                .map(m => m.data)
            return mention

        }
       

        const onChange = e => {
            $('.rdw-suggestion-dropdown').css({ "left": "60px", "width": "200px" })
           
            const tag = parseMention(e)
            if (tag.length > 0) {
                members = members.filter(m => tag.map(e => e.url).indexOf(m.url) < 0)
            } else {
                members = allMembers
            }
          
            dispatch({ 
                type: "SET_FILE_ACTION_COMMENTS", 
                action: type,
                data: { 
                    ...conversation.Actions[type], 
                    comment: JSON.stringify(e)
                } 
            });
            if(this.props.handleChange) {
                this.props.handleChange(JSON.stringify(e))
            }
        }

        const CompActions = props => {
            return <Actions {...props}
                onAction={() => {
                    this.setState({
                        contentState: null,
                        editorState: EditorState.createEmpty(),
                    },()=>{
                        dispatch({type:"CLEAR_FILE_ACTION_COMMENTS"})
                    }
                    )
                }} 
                isEnabled={this.props.isEnabled}
                type={type}
                submit={this.props.submit}
                />
        }
     
      
      let   option = ["inline", "list", "fontSize", "emoji"]
      let   toolBar = {
            inline: {
                component: (props)=>{return <Inline {...props} postFix={type}/>}
            },
            list: {
                component: (props)=>{return <List {...props} postFix={type}/>}
            },
            fontSize: {
                component: CompActions
            },
            emoji: {
                component: Emoji
            }
         
        }
     
        if (type && type === 'update') {
            option = ["inline", "list", "emoji"]
            toolBar = {
                inline: {
                    component: (props)=>{return <Inline {...props} postFix={type}/>}
                },
                list: {
                    component: (props)=>{return <List  {...props} postFix={type}/>}
                },
                emoji: {
                    component: Emoji
                }

            }
        }
        const optionsToolbar = {
            options: option,
            ...toolBar

        }
        const obj = $(`.fileComments.${type}`)
        if(type && obj.length>0) {
            const hasFocus = obj.find('.public-DraftEditorPlaceholder-hasFocus').length
            if( hasFocus || this.props.isEnabled || (type && type === 'update')){
                
                $(`#comment-inline-${type}`).removeClass('hide')
                $(`#comment-list-${type}`).removeClass('hide')
                obj.removeClass('hideTextFormat')
            } else {
                 
                $(`#comment-inline-${type}`).addClass('hide')
                $(`#comment-list-${type}`).addClass('hide')  
                obj.addClass('hideTextFormat') 
            }
        }
       
        const onEdit = type === "update"
        return (
            <div class={`text-editor-container ${this.props.classes ? this.props.classes : ""} ${onEdit ? "editMessage" : ""} `}>
                <Editor
                    editorState={this.state.editorState}
                    wrapperClassName="text-editor-wrapper"
                    editorClassName="text-editor-inner-container"
                    toolbarClassName="text-editor-toolbar"
                    onEditorStateChange={onEditorStateChange}
                    onChange={onChange}
                    stripPastedStyles={true}
                    placeholder={'Add your message here...'}
                    toolbar={optionsToolbar}
                    mention={{
                        separator: ' ',
                        trigger: '@',
                        suggestions: members
                    }}
                />
              
            </div>
        );
    }
}

export default TextEditor;